// v2
function registerShippingProtection() {
  if (!customElements.get('shipping-protection')) {
    customElements.define(
      'shipping-protection',
      class ShippingProtection extends HTMLElement {
        constructor() {
          super();
        }

        get variantId() {
          return this.getAttribute('data-variant-id');
        }

        get checkbox() {
          return this.querySelector('.shipping-protection__checkbox');
        }

        get loader() {
          return this.querySelector('.loader');
        }

        connectedCallback() {
          if (!this.checkbox) return;

          this.checkbox.addEventListener('change', (event) => {
            setTimeout(() => {
              event.target.checked ? this.addProtection() : this.removeProtection();
            }, 300);
          });
        }

        addProtection() {
          this.enableLoading();

          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

          const body = JSON.stringify({
            items: [{ id: parseInt(this.variantId), quantity: 1 }],
            sections: sectionsToBundle
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          })
            .then((response) => response.json())
            .then(async (parsedState) => {
              const cartJson = await (await fetch('/cart.js', {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              })).json();
              cartJson['sections'] = parsedState['sections'];
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cart: cartJson });
            })
            .catch((error) => {
              console.error('ShippingProtection add error:', error);
              if (this.checkbox) this.checkbox.checked = false;
            });
        }

        removeProtection() {
          this.enableLoading();

          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

          const body = JSON.stringify({
            updates: { [this.variantId]: 0 },
            sections: sectionsToBundle
          });

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          })
            .then((response) => response.json())
            .then((parsedState) => {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cart: parsedState });
            })
            .catch((error) => {
              console.error('ShippingProtection remove error:', error);
              if (this.checkbox) this.checkbox.checked = true;
            });
        }

        enableLoading() {
          if (this.loader) this.loader.hidden = false;
        }
      }
    );
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerShippingProtection);
} else {
  registerShippingProtection();
}